/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyOBUType
 */
export interface WriteOnlyOBUType {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyOBUType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyOBUType
     */
    name: string;
}

export function WriteOnlyOBUTypeFromJSON(json: any): WriteOnlyOBUType {
    return WriteOnlyOBUTypeFromJSONTyped(json, false);
}

export function WriteOnlyOBUTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyOBUType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
    };
}

export function WriteOnlyOBUTypeToJSON(value?: WriteOnlyOBUType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


